import { forwardRef, memo } from 'react'
import { StaticImageData } from 'next/image'
import Link from 'next/link'
import classNames from 'classnames'

import css from './PhotoGrid.module.scss'

import routes from '@/data/routes'

import BaseImage from '@/components/BaseImage/BaseImage'

export type PhotoGridProps = {
  className?: string
  images: StaticImageData[]
}

export const PhotoGrid = forwardRef<HTMLDivElement, PhotoGridProps>(({ className, images }, ref) => {
  return (
    <div className={classNames('PhotoGrid', css.root, className)} ref={ref}>
      {images.map((data, i) => {
        return (
          <Link href={routes.Gallery.path} key={i} className={css.linkImage} scroll={false}>
            <BaseImage
              key={`photo-gallery-${i}`}
              className={css.image}
              data={data}
              fill={false}
              nextImageClassName="CursorPhoto"
            />
          </Link>
        )
      })}
    </div>
  )
})

export default memo(PhotoGrid)
